import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import React, { useEffect, useMemo, useState } from 'react';
import { useEventListener } from '@beef/react';
import { AutoMetricContext } from "./context";
import { getContextAtNode } from "./internals";
import { AutoMetricBlockType, AutoMetricEventType, AutoMetricNode } from "../core";
import { useAutoMetricNodeParams } from "./hooks/useAutoMetricParams";
import { getClickableElement, getComponentTestId, getInteractiveElement } from "../core/dom";
export var AutoMetricRoot = function AutoMetricRoot(_ref) {
  var children = _ref.children,
    api = _ref.api,
    _ref$params = _ref.params,
    params = _ref$params === void 0 ? {} : _ref$params;
  var _useState = useState(function () {
      return new AutoMetricNode(AutoMetricBlockType.ROOT);
    }),
    _useState2 = _slicedToArray(_useState, 1),
    node = _useState2[0];
  useAutoMetricNodeParams(node, params);
  useEventListener('click', function (event) {
    if (!(event.target instanceof Element)) return;
    var element = getClickableElement(event.target) || getInteractiveElement(event.target);
    if (!element) return;
    var context = getContextAtNode(event.target, AutoMetricContext);
    api.publish(AutoMetricEventType.CLICK, context.node, {
      element: element,
      name: getComponentTestId(element),
      goal: context.goals[AutoMetricEventType.CLICK]
    });
  }, typeof document !== 'undefined' ? document.body : undefined, {
    mode: {
      capture: true
    }
  });
  useEffect(function () {
    api.publish(AutoMetricEventType.VIEW, node);
    // NOTE: should only fire events once, even if something changes
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  var context = useMemo(function () {
    return {
      api: api,
      node: node,
      goals: {}
    };
  }, [api, node]);
  return /*#__PURE__*/React.createElement(AutoMetricContext.Provider, {
    value: context
  }, children);
};